/**
 * Per-apiKey session-token persistence for the Preact chat widget.
 *
 * Storage is keyed by API key so multiple widgets for different agents on
 * the same origin don't clobber each other's tokens. The BE correlates
 * history via `X-Session-Token` (or the legacy `ck_session_id` cookie);
 * WS auth never sets that cookie, so the header path is required.
 */
const STORAGE_KEY_PREFIX = 'circuit-chat-widget:session:';

export const SESSION_TOKEN_HEADER = 'X-Session-Token';

export function sessionStorageKey(apiKey: string): string {
  return `${STORAGE_KEY_PREFIX}${apiKey}`;
}

export function readSessionToken(apiKey: string): string | null {
  try {
    return globalThis.localStorage?.getItem(sessionStorageKey(apiKey)) ?? null;
  } catch {
    return null;
  }
}

export function writeSessionToken(apiKey: string, token: string): void {
  try {
    globalThis.localStorage?.setItem(sessionStorageKey(apiKey), token);
  } catch {
    /* localStorage unavailable (private mode, ITP) -- session won't persist. */
  }
}
